<template>
  <section class="page-copy">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <h1>Please download latest OpenCabana Guest App!</h1>
          <a href="https://itunes.apple.com/us/app/opencabana/id1267799200?mt=8&ign-mpt=uo%3D4"><img :src="applePlayBtn"></a>
          <a class="app-store-button" href="https://play.google.com/store/apps/details?id=com.opencabanaguest"><img :src="googlePlayBtn"></a>
        </div>
      </div>
    </div><!-- end .container -->
  </section>
</template>

<script>
export default {
  name: 'Apps',
  data() {
    return {
      applePlayBtn: require('assets/images/btn-apple-app.png'),
      googlePlayBtn: require('assets/images/btn-google-play.png')
    }
  }
}
</script>



// WEBPACK FOOTER //
// apps.vue?52e1f6e9